"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = exports.init = void 0;
var reconnect_js_1 = require("reconnect.js");
function _getVersionFromHost(host) {
    return host.split('/')[3];
}
var ConfigGetter = /** @class */ (function () {
    function ConfigGetter(params) {
        this._clientId = params.clientId;
        this._primaryUserType = params.primaryUserType;
        this._stage = params.stage;
        this._webHost = params.webHost;
        this._apiHost = params.apiHost;
        this._authHost = params.authHost;
        this._storageHost = params.storageHost;
        this._articleEditorHost = params.articleEditorHost;
        this._management = !!params.management;
        this._legacyUserTokenStorage = !!params.legacyUserTokenStorage;
        this._fastelVersion = params.fastelVersion;
        if (params.authVersion) {
            this._authVersion = params.authVersion;
            this._authHost = "https://auth" + (this._stage === 'stg' ? '-stg' : '') + ".revtel-api.com/" + this._authVersion;
        }
        else {
            this._authHost = params.authHost;
            if (this._authHost) {
                this._authVersion = _getVersionFromHost(this._authHost);
            }
        }
        if (params.jstoreVersion) {
            this._jstoreVersion = params.jstoreVersion;
            this._jstoreHost = "https://jstorage" + (this._stage === 'stg' ? '-stg' : '') + ".revtel-api.com/" + this._jstoreVersion;
        }
        else {
            this._jstoreHost = params.jstoreHost;
            if (this._jstoreHost) {
                this._jstoreVersion = _getVersionFromHost(this._jstoreHost);
            }
        }
        if (params.storageVersion) {
            this._storageVersion = params.storageVersion;
            this._storageHost = "https://storage" + (this._stage === 'stg' ? '-stg' : '') + ".revtel-api.com/" + this._storageVersion;
        }
        else {
            this._storageHost = params.storageHost;
            if (this._storageHost) {
                this._storageVersion = _getVersionFromHost(this._storageHost);
            }
        }
        if (params.notificationVersion) {
            this._notificationVersion = params.notificationVersion;
            this._notificationHost = "https://notification" + (this._stage === 'stg' ? '-stg' : '') + ".revtel-api.com/" + this._notificationVersion;
        }
        else {
            this._notificationHost = params.notificationHost;
            if (this._notificationHost) {
                this._notificationVersion = _getVersionFromHost(this._notificationHost);
            }
        }
        if (this.stage === 'prod') {
            this._discoveryHost = 'https://discovery.revtel-api.com/v1';
        }
        else {
            this._discoveryHost = 'https://discovery-stg.revtel-api.com/v1';
        }
    }
    Object.defineProperty(ConfigGetter.prototype, "clientId", {
        get: function () {
            return this._clientId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigGetter.prototype, "primaryUserType", {
        get: function () {
            return this._primaryUserType || 'email';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigGetter.prototype, "stage", {
        get: function () {
            return this._stage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigGetter.prototype, "discoveryHost", {
        get: function () {
            return this._discoveryHost;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigGetter.prototype, "webHost", {
        get: function () {
            return this._webHost || '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigGetter.prototype, "apiHost", {
        get: function () {
            return this._apiHost || '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigGetter.prototype, "authHost", {
        get: function () {
            return this._authHost || '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigGetter.prototype, "authVersion", {
        get: function () {
            return this._authVersion || '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigGetter.prototype, "jstoreHost", {
        get: function () {
            return this._jstoreHost || '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigGetter.prototype, "jstoreVersion", {
        get: function () {
            return this._jstoreVersion || '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigGetter.prototype, "storageHost", {
        get: function () {
            return this._storageHost || '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigGetter.prototype, "storageVersion", {
        get: function () {
            return this._storageVersion || '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigGetter.prototype, "notificationHost", {
        get: function () {
            return this._notificationHost || '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigGetter.prototype, "notificationVersion", {
        get: function () {
            return this._notificationVersion || '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigGetter.prototype, "articleEditorHost", {
        get: function () {
            return this._articleEditorHost || '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigGetter.prototype, "management", {
        get: function () {
            return this._management;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigGetter.prototype, "legacyUserTokenStorage", {
        get: function () {
            return this._legacyUserTokenStorage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigGetter.prototype, "fastelVersion", {
        get: function () {
            return this._fastelVersion;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigGetter.prototype, "UserOutlet", {
        get: function () {
            return reconnect_js_1.getOutlet('user');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigGetter.prototype, "CartOutlet", {
        get: function () {
            return reconnect_js_1.getOutlet('cart');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigGetter.prototype, "actions", {
        get: function () {
            return reconnect_js_1.getOutlet('actions').getValue();
        },
        enumerable: false,
        configurable: true
    });
    // following APIs are only used by rev.console
    ConfigGetter.prototype.updateClientId = function (clientId) {
        this._clientId = clientId;
    };
    ConfigGetter.prototype.updateAuth = function (config) {
        this._authHost = config.host;
        this._authVersion = config.version;
    };
    ConfigGetter.prototype.updateJStore = function (config) {
        this._jstoreHost = config.host;
        this._jstoreVersion = config.version;
    };
    ConfigGetter.prototype.updateStorage = function (config) {
        this._storageHost = config.host;
        this._storageVersion = config.version;
    };
    ConfigGetter.prototype.updateNotification = function (config) {
        this._notificationHost = config.host;
        this._notificationVersion = config.version;
    };
    return ConfigGetter;
}());
var singleton;
function init(cfg) {
    singleton = new ConfigGetter(cfg);
}
exports.init = init;
function get() {
    return singleton;
}
exports.get = get;
